

















import { Component, Prop, Vue } from 'vue-property-decorator';
import CloseIcon from '@/assets/icons/close.svg';

@Component({
    components: {
        CloseIcon,
    },
})
export default class MarkerPopup extends Vue {
    @Prop({ type: String, required: true })
    title!: string;

    @Prop({ type: String, required: false, default: null })
    subtitle!: string | null;

    @Prop({ type: Boolean, required: false, default: true })
    promoted!: boolean | true;

    @Prop({ type: String, required: true })
    image!: string;

    @Prop({ type: Boolean, required: false, default: false })
    mobile!: boolean;
}
